<section class="accounting-firm-benefit-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="accounting-firm-topic">
      <!-- desktop heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--desktop color-gray"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.HEADING' | translate"
      ></div>

      <!-- tablet heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--tablet color-gray"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.HEADING_TABLET' | translate"
      ></div>

      <!-- mobile heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--mobile color-gray"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.HEADING_MOBILE' | translate"
      ></div>
    </div>

    <div class="table-box">
      <!-- 1 -->
      <div class="table-box__item table-box__item--1">
        <div class="table-box__item-logo">
          <i class="fas fa-users"></i>
        </div>
        <div class="table-box__item-title color-gray">
          {{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.TOPIC_1' | translate }}</div
        >
        <div class="table-box__item-detail">{{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.DETAIL_1' | translate }}</div>
      </div>

      <!-- 2 -->
      <div class="table-box__item table-box__item--2">
        <div class="table-box__item-logo">
          <i class="fas fa-business-time"></i>
        </div>
        <div class="table-box__item-title color-gray">
          {{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.TOPIC_2' | translate }}</div
        >
        <div class="table-box__item-detail">{{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.DETAIL_2' | translate }}</div>
      </div>

      <!-- 3 -->
      <div class="table-box__item table-box__item--3">
        <div class="table-box__item-logo">
          <i class="fas fa-chart-line"></i>
        </div>
        <div class="table-box__item-title color-gray">
          {{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.TOPIC_3' | translate }}</div
        >
        <div class="table-box__item-detail">{{ 'NEW_ACCOUNTING_FIRM.BENEFIT_SECTION.ITEM.DETAIL_3' | translate }}</div>
      </div>
    </div>
  </div>
</section>
